import { Lesson } from "./Lessons";
import User from "./User";

export type TimelineAction = {
  id: string;
  timestamp: number;
  action_type: TimelineActionType;
  user: User;
  lesson?: Lesson;
};

export enum TimelineActionType {
  workspace_created,
  lesson_created,
  workspace_joined,
  solution_approved,
  file_imported
}